import { Link } from 'react-router-dom'
import { Compass } from 'lucide-react'
import { EmptyState } from '@/components/feedback/EmptyState'
import { DEFAULT_ROUTE } from '../navigation'

export function NotFoundPage() {
  return (
    <EmptyState
      icon={Compass}
      title="Página não encontrada"
      description="O endereço acessado não existe no Woctools. Ele pode ter sido removido na nova versão."
      action={
        <Link
          to={DEFAULT_ROUTE}
          className="text-sm font-medium text-primary-text underline-offset-4 hover:underline"
        >
          Ir para Agendamentos › Pedidos
        </Link>
      }
    />
  )
}
